import { CopyLink } from '@components/common/CopyLink';
import { Dashboard } from '@components/common/Dashboard';
import React from 'react';
import { useOverviewContext } from '../../hooks/useOverviewContext';
import { HeaderSkeleton } from './HeaderSkeleton';
import * as S from './styled';
export const Header = () => {
    const overview = useOverviewContext();
    if (overview.isLoading ||
        overview.membershipsUrl === null ||
        overview.membershipsStatus === null) {
        return React.createElement(HeaderSkeleton, null);
    }
    if (overview.onboarding.active)
        return null;
    return (React.createElement(Dashboard.Section, { name: "Memberships overview", title: overview.membershipsStatus === 'Live' ? (React.createElement(S.Title, null,
            "Your members-only area is available at\u00A0",
            ' ',
            React.createElement(S.CopyLinkWrapper, null,
                React.createElement(CopyLink, { label: overview.membershipsUrl.label, href: overview.membershipsUrl.href })))) : null, bottomMargin: "large" }));
};
